module.exports = __webpack_public_path__ + "static/media/xlgldyj.66d3b75d.png";